import React from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';

import { Panel, Segments, Empty } from '../kit.js';
import { Icon } from './glyphs.js';
import { EventRow } from './parts.js';

const EASE = [0.16, 1, 0.3, 1];
const SHOWN = 40;

export const FEED_FILTERS = {
    All: () => true,
    Granted: e => e.kind === 'granted',
    Denied: e => e.kind === 'denied',
    Alarms: e => e.kind === 'alarm'
};

/* The live activity stream beside the door grid. New events slide in
   at the top and push the rest down; pausing it stops the building's
   background traffic as well, so a demo can stop on a moment. */
export function EventFeed({ events, running, onToggle, filter, onFilter, index = 0 }) {
    const reduced = useReducedMotion();
    const shown = events.filter(FEED_FILTERS[filter]).slice(0, SHOWN);
    const count = key => events.filter(FEED_FILTERS[key]).length;

    return (
        <Panel index={index} className="acc-feed">
            <div className="acc-feed__head">
                <div className="acc-feed__title">
                    <h4>Live activity</h4>
                    <span className={`acc-live${running ? ' acc-live--on' : ''}`}>
                        <span className="acc-live__dot" />{running ? 'Streaming' : 'Paused'}
                    </span>
                </div>
                <button type="button" className="btn btn-outline-light btn-sm" onClick={onToggle} aria-pressed={!running}>
                    <Icon name={running ? 'pause' : 'play'} size={14} /> {running ? 'Pause' : 'Resume'}
                </button>
            </div>

            <Segments
                label="Filter activity"
                value={filter}
                onChange={onFilter}
                options={Object.keys(FEED_FILTERS).map(key => ({
                    value: key,
                    label: key === 'All' ? 'All' : `${key} ${count(key)}`
                }))}
            />

            <div className="acc-feed__wrap">
                {shown.length === 0 ? <Empty>No {filter.toLowerCase()} events yet.</Empty> : (
                    <ul className="acc-feed__list">
                        <AnimatePresence initial={false}>
                            {shown.map(event => (
                                <motion.li
                                    key={event.id}
                                    layout={reduced ? false : 'position'}
                                    className="acc-feed__item"
                                    initial={reduced ? false : { opacity: 0, y: -14, backgroundColor: 'rgba(163, 231, 252, 0.10)' }}
                                    animate={{ opacity: 1, y: 0, backgroundColor: 'rgba(163, 231, 252, 0)' }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.55, ease: EASE, backgroundColor: { duration: 2.4 } }}
                                >
                                    <EventRow event={event} />
                                </motion.li>
                            ))}
                        </AnimatePresence>
                    </ul>
                )}
            </div>
        </Panel>
    );
}
